import { z } from 'zod';

/**
 * Receipt — physical delivery event against a PO. Items capture what
 * actually arrived vs what was ordered; the API derives PO status
 * (`partially_received` / `received`) from the cumulative receipt items.
 */
export const receiptItemSchema = z.object({
  // W157 · id estável da linha do PO que este recebimento cobre.
  // Opcional pra compat com clients/recibos legados (sem lineId, o
  // backend cai pro agrupamento por descrição). Quando presente, o
  // roll-up de status do PO chaveia por lineId — evitando mesclar
  // linhas homônimas (mesma descrição, ids diferentes).
  lineId: z.string().optional(),
  description: z.string().trim().min(1).max(200),
  quantityReceived: z.number().min(0).max(999_999),
  quantityDamaged: z.number().min(0).max(999_999).default(0),
  notes: z.string().trim().max(500).optional(),
});
export type ReceiptItem = z.infer<typeof receiptItemSchema>;

export const receiptSchema = z.object({
  id: z.string(),
  projectId: z.string(),
  purchaseOrderId: z.string(),
  code: z.string(),
  receivedAt: z.string(),
  items: z.array(receiptItemSchema),
  attachmentId: z.string().nullable(),
  notes: z.string().nullable(),
  receivedBy: z.string(),
  receivedByName: z.string(),
  createdAt: z.string(),
});
export type Receipt = z.infer<typeof receiptSchema>;

export const createReceiptRequestSchema = z.object({
  purchaseOrderId: z.string(),
  receivedAt: z.string().datetime({ offset: true }).optional(),
  items: z.array(receiptItemSchema).min(1).max(200),
  attachmentId: z.string().optional(),
  notes: z.string().trim().max(2000).optional(),
});
export type CreateReceiptRequest = z.infer<typeof createReceiptRequestSchema>;
